import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../hooks/useWallet';
import '../styles/send.css';

function Send() {
  const navigate = useNavigate();

  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonText, setComingSoonText] = useState('');

  const showComingSoonMessage = (text) => {
    setComingSoonText(text);
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 2000);
  };

  const sendOptions = [
    {
      icon: <span style={{fontSize: '1.7rem'}}>📄</span>,
      title: 'Send to Wallet',
      desc: 'Send money to other Corre users',
      onClick: () => navigate('/send/wallet'),
      testid: 'send-wallet',
    },
    {
      icon: <span style={{fontSize: '1.7rem'}}>📱</span>,
      title: 'Send to Mobile Money',
      desc: 'Send money to mobile money accounts',
      onClick: () => showComingSoonMessage('Mobile Money coming soon!'),
      testid: 'send-mobile',
      comingSoon: true
    },
    {
      icon: <span style={{fontSize: '1.7rem'}}>🏦</span>,
      title: 'Send to Bank',
      desc: 'Send money to bank accounts',
      onClick: () => navigate('/transfer'),
      testid: 'send-bank',
    },
    {
      icon: <span style={{fontSize: '1.7rem'}}>💵</span>,
      title: 'Send using MoneyGram',
      desc: 'Send money using MoneyGram',
      onClick: () => showComingSoonMessage('MoneyGram integration coming soon!'),
      testid: 'send-moneygram',
      comingSoon: true
    },
  ];

  return (
    <div className="send-page-bg">
      <div className="send-page-container">
        <h1 className="send-page-title">Send Funds</h1>
        <div className="send-options-list">
          {sendOptions.map(option => (
            <button
              key={option.title}
              className={`send-option-card ${option.comingSoon ? 'coming-soon' : ''}`}
              onClick={option.onClick}
              data-testid={option.testid}
            >
              <div className="send-option-icon">{option.icon}</div>
              <div>
                <div className="send-option-title">
                  {option.title}
                  {option.comingSoon && (
                    <span className="coming-soon-badge">Coming Soon</span>
                  )}
                </div>
                <div className="send-option-desc">{option.desc}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Coming Soon Toast */}
      {showComingSoon && (
        <div className="coming-soon-toast">
          {comingSoonText}
        </div>
      )}
      <style>{`
        .send-page-bg {
          min-height: 100vh;
          background: #f7f9fa;
          display: flex;
          align-items: flex-start;
          justify-content: center;
        }
        .send-page-container {
          margin: 64px auto 0 auto;
          max-width: 700px;
          width: 100%;
        }
        .send-page-title {
          font-size: 2.1rem;
          font-weight: 800;
          margin-bottom: 2.5rem;
          color: #181c23;
          letter-spacing: -1px;
        }
        .send-options-list {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }
        .send-option-card {
          display: flex;
          align-items: flex-start;
          gap: 1.1rem;
          background: #fff;
          border: none;
          border-radius: 12px;
          box-shadow: none;
          padding: 1.1rem 2.1rem 1.1rem 1.1rem;
          cursor: pointer;
          transition: background 0.15s;
          min-width: 320px;
          max-width: 480px;
          width: 100%;
          text-align: left;
        }
        .send-option-card:hover {
          background: #f3f4f6;
        }
        .send-option-icon {
          background: #f2f5fa;
          border-radius: 8px;
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 0.7rem;
        }
        .send-option-title {
          font-weight: 600;
          font-size: 1.08rem;
          color: #232a36;
        }
        .send-option-desc {
          font-size: 0.97rem;
          color: #3072c7;
          margin-top: 2px;
        }
        .coming-soon-badge {
          background: #f0f4ff;
          color: #2d6ae3;
          font-size: 0.7rem;
          padding: 2px 6px;
          border-radius: 10px;
          margin-left: 8px;
          font-weight: 500;
        }
        .coming-soon {
          opacity: 0.8;
          position: relative;
        }
        .coming-soon-toast {
          position: fixed;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0, 0, 0, 0.8);
          color: white;
          padding: 12px 24px;
          border-radius: 24px;
          font-size: 0.95rem;
          z-index: 1000;
          animation: fadeInOut 2s ease-in-out;
        }
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translate(-50%, 20px); }
          15% { opacity: 1; transform: translate(-50%, 0); }
          85% { opacity: 1; transform: translate(-50%, 0); }
          100% { opacity: 0; transform: translate(-50%, -10px); }
        }
        @media (max-width: 600px) {
          .send-page-container {
            margin-top: 32px;
            padding: 0 1rem;
          }
          .send-page-title {
            font-size: 1.4rem;
          }
          .send-option-card {
            padding: 1rem 1.1rem;
            min-width: unset;
            max-width: unset;
          }
        }
      `}</style>
    </div>
  );
}



export default Send;
